import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "../i18n";
import { DemandInput, type DemandValue } from "../components/DemandInput";

export function NewRequest() {
  const { t } = useT();
  const navigate = useNavigate();
  const [demand, setDemand] = useState<DemandValue>({ mode: "text" });
  const [sent, setSent] = useState(false);

  const demandFilled = Boolean(
    demand.text?.trim() || demand.transcript?.trim() || demand.fileNames?.length,
  );

  const submit = () => {
    setSent(true);
    setTimeout(() => navigate("/app"), 1200);
  };

  return (
    <div className="panel wide">
      <span className="eyebrow">{t("dashboardEyebrow")}</span>
      <h2>{t("newRequestTitle")}</h2>

      <div style={{ margin: "18px 0" }}>
        <DemandInput value={demand} onChange={setDemand} />
      </div>

      <div className="row">
        <button className="btn primary" type="button" disabled={!demandFilled} onClick={submit}>
          {t("submitRequest")}
        </button>
        {sent && <span className="ok">{t("requestSent")}</span>}
      </div>
    </div>
  );
}
